import { ThemeProvider } from "styled-components";
import { useState } from "react";
import styled, { keyframes } from "styled-components";
import { darkTheme, lightTheme } from "./utils/Themes.js";
import Navbar from "./components/Navbar";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import HeroSection from "./components/HeroSection";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Experience from "./components/Experience";
import Education from "./components/Education";
import ProjectDetails from "./components/ProjectDetails";
import Credentials from "./components/Credentials";

const drift = keyframes`
  0% { transform: translate3d(0, 0, 0) scale(1); }
  50% { transform: translate3d(30px, -24px, 0) scale(1.08); }
  100% { transform: translate3d(0, 0, 0) scale(1); }
`;

const Stage = styled.div`
  position: relative;
  min-height: 100vh;
  background:
    radial-gradient(900px 500px at 10% -10%, rgba(62, 224, 197, 0.16), transparent 55%),
    radial-gradient(700px 420px at 100% 8%, rgba(245, 185, 66, 0.12), transparent 50%),
    ${({ theme }) => theme.bg};
`;

const Orb = styled.div`
  position: fixed;
  z-index: 0;
  pointer-events: none;
  border-radius: 50%;
  filter: blur(8px);
  animation: ${drift} 14s ease-in-out infinite;
  width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
  left: ${({ $left }) => $left};
  top: ${({ $top }) => $top};
  background: ${({ $color }) => $color};
  animation-delay: ${({ $delay }) => $delay};
`;

const Body = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  overflow-x: hidden;
`;

function App() {
  const [darkMode] = useState(true);
  const [openModal, setOpenModal] = useState({ state: false, project: null });

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <Router>
        <Stage>
          <Orb $size="280px" $left="-80px" $top="120px" $delay="0s" $color="rgba(62, 224, 197, 0.16)" />
          <Orb $size="220px" $left="72%" $top="40px" $delay="-4s" $color="rgba(245, 185, 66, 0.12)" />
          <Orb $size="180px" $left="40%" $top="68%" $delay="-8s" $color="rgba(62, 224, 197, 0.08)" />
          <Navbar />
          <Body>
            <HeroSection />
            <Skills />
            <Experience />
            <Projects openModal={openModal} setOpenModal={setOpenModal} />
            <Education />
            <Credentials />
            <Contact />
            <Footer />
            {openModal.state && (
              <ProjectDetails openModal={openModal} setOpenModal={setOpenModal} />
            )}
          </Body>
        </Stage>
      </Router>
    </ThemeProvider>
  );
}

export default App;
